import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '@auth/bp-pf-auth';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const router = inject(Router);

  const pathSegments = window.location.pathname.split('/');
  
  const tenant = pathSegments[1] || getCookie(`${environment.app_id}_tenant_code`);
  const token = getCookie(`${tenant}_${environment.app_id}_access_token`);
  
  const wasLoggedIn = localStorage.getItem(`${tenant}_${environment.app_id}_wasLoggedIn`) === 'true';

  if (!token) {
    //  Store returnUrl temporarily
    if (tenant) {
      localStorage.setItem(`${tenant}_${environment.app_id}_returnUrl`, state.url);
    }

    if (wasLoggedIn) {
      router.navigate(['/', tenant, 'logout']);
    } else {
      router.navigate(['/', tenant]);
    }
    return false;
  }
  return true;
};
